package com.eladfinish.bible.contest.screens.search.model

import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.ImmutableList

sealed interface LocalSearchResult {

    /**
     * How many results the run itself found. The store's state can lag behind it: the results
     * reach the state through actions that are reduced asynchronously, so a decision taken when
     * the run ends has to read this count, not the state's list.
     */
    val resultsCount: Int

    data class Completed(
        val results: ImmutableList<VerseUiModel>,
        val differentVersesNum: Int,
        val message: StringDesc,
        val finalRegex: String,
        val wasInterrupted: Boolean,
    ) : LocalSearchResult {
        override val resultsCount: Int
            get() = results.size
    }

    data class Failure(
        val message: String,
        val throwable: Throwable,
        override val resultsCount: Int,
    ) : LocalSearchResult
}
